import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";

import CrossCountry from "~/types/cross-country";

import RevieveModalTrigger from "../editorials/revieve-modal-trigger/revieve-modal-trigger";
import Breadcrumbs, { Breadcrumb } from "./product-breadcrumbs";
import ProductDetailTags from "./product-detail-tags";
import ProductGalleryNavigator from "./product-gallery-navigator";
import styles from "./product-intro.module.scss";

type Props = {
  root: CrossCountry.DetailedProduct;
  selectedShade: CrossCountry.DetailedProduct;
  galleryIdx: number;
  onSelect: (galleryElIdx: number) => void;
  breadcrumbs: Breadcrumb[];
  enabledGallery: boolean;
  setEnabledGallery: Dispatch<SetStateAction<boolean>>;
};

export default function ProductIntro(props: Props) {
  const t = useTranslations();

  return (
    <div className={styles.pdpIntro}>
      <Breadcrumbs breadcrumbs={props.breadcrumbs} className={styles.pdpIntroBreadcrumb} />
      <ProductDetailTags product={props.selectedShade} />
      <h1 className={styles.productName}>{props.root.display_value?.toLowerCase()}</h1>
      <div
        className={styles.pdpShortDesc}
        dangerouslySetInnerHTML={{ __html: props.selectedShade?.short_description }}
      />
      <div className={styles.showOnDesktopOnly}>
        <RevieveModalTrigger
          revieveType="PDPVirtualTryOn"
          variant="serviceBig"
          buttonText={t("generic.tryitnow")}
          productId={props.selectedShade.backend_id}
          renderToId="revieve-target"
          hidden={!props.selectedShade.try_it_on}
          onOpen={() => props.setEnabledGallery(false)}
          onClose={() => props.setEnabledGallery(true)}
        />
        <ProductGalleryNavigator
          selectedShade={props.selectedShade}
          galleryIdx={props.galleryIdx}
          onSelect={props.onSelect}
          enabledGallery={props.enabledGallery}
        />
      </div>
    </div>
  );
}
